import styled from "styled-components"

export const Container = styled.div`
  width: 100%;
  position: relative;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`

export const BackLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.turquoiseDark};
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;

  svg {
    width: 1.2rem;
    height: 1.2rem;
  }
`

export const NameInput = styled.input`
  flex: 1;
  min-width: 15rem;
  padding: 0.8rem 1rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  font-size: 1.4rem;
  ${(p) => p.theme.bold};
  color: ${(p) => p.theme.colors.black};
  background: ${(p) => p.theme.colors.white};

  &:focus {
    outline: none;
    border-color: ${(p) => p.theme.colors.turquoiseDark};
  }
`

export const StatusBadge = styled.span<{ $published?: boolean }>`
  font-size: 1.1rem;
  padding: 0.3rem 0.8rem;
  border-radius: 0.3rem;
  white-space: nowrap;
  background: ${(p) =>
    p.$published ? p.theme.colors.turquoiseDark : p.theme.colors.greyLight};
  color: ${(p) =>
    p.$published ? p.theme.colors.white : p.theme.colors.greyDarker};
`

export const DraftIndicator = styled.span`
  display: inline-block;
  font-size: 1.1rem;
  padding: 0.3rem 0.8rem;
  border-radius: 0.3rem;
  white-space: nowrap;
  background: #fef3c7;
  color: #92400e;
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.8rem;
  margin-left: auto;
`

export const CanvasSection = styled.div`
  display: flex;
`

export const TabsContainer = styled.div`
  margin-top: 1rem;

  .react-tabs {
    -webkit-tap-highlight-color: transparent;
  }

  .react-tabs__tab-list {
    margin: 0;
    padding: 0.8rem;
    display: flex;
    background: ${(p) => p.theme.colors.greyLightest};
    border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
    border-radius: 0.6rem;
  }

  .react-tabs__tab {
    display: inline-block;
    border: none;
    bottom: -1px;
    position: relative;
    list-style: none;
    padding: 0 1.5rem;
    cursor: pointer;
    font-size: 1.2rem;
    border-radius: 0.6rem;
    color: ${(p) => p.theme.colors.greyDark};
  }

  .react-tabs__tab--selected {
    border: none;
    background: ${(p) => p.theme.colors.greyLight};
    color: ${(p) => p.theme.colors.black};
  }

  .react-tabs__tab--disabled {
    color: GrayText;
    cursor: default;
  }

  .react-tabs__tab:focus {
    outline: none;
  }

  .react-tabs__tab:focus:after {
    display: none;
  }

  .react-tabs__tab-panel {
    display: none;
  }

  .react-tabs__tab-panel--selected {
    display: block;
    margin-top: 1.5rem;
  }
`
